// extracted by mini-css-extract-plugin
module.exports = {"divisions":"DivisionsScreen_divisions__eoqUg","left":"DivisionsScreen_left__mSG2_"};